document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('[data-mobile-menu-button]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (button && menu) {
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
  }

  document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    const form = picker.closest('form');
    const selects = Array.from(picker.querySelectorAll('[data-option-select]'));
    const variantInput = picker.querySelector('[data-variant-id]');
    const variantsElement = picker.querySelector('[data-product-variants]');
    const submit = form?.querySelector('[type="submit"]');
    const price = form?.closest('[data-product-info]')?.querySelector('[data-product-price]');
    if (!variantInput || !variantsElement || selects.length === 0) return;

    const variants = JSON.parse(variantsElement.textContent);
    const findVariant = () => {
      const selected = selects.map((select) => select.value);
      return variants.find((variant) => variant.options.every((option, index) => option === selected[index]));
    };
    const updateUrl = (variant) => {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    const applyVariant = (variant, displayPrice = true) => {
      if (!variant) {
        variantInput.value = '';
        if (submit) {
          submit.disabled = true;
          submit.textContent = submit.dataset.unavailableText;
        }
        return;
      }
      variantInput.value = variant.id;
      if (price && displayPrice) price.textContent = variant.price;
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? submit.dataset.availableText : submit.dataset.soldText;
      }
      updateUrl(variant);
    };

    if (picker.hasAttribute('data-area-calculator')) {
      const calculator = form.querySelector('[data-area-fields]');
      const jobsContainer = form.querySelector('[data-area-jobs]');
      const addJobButton = form.querySelector('[data-area-add]');
      const quantity = form.querySelector('[data-area-quantity]');
      const result = form.querySelector('[data-area-result]');
      const properties = {
        jobsCount: form.querySelector('[data-area-property-jobs-count]'),
        exact: form.querySelector('[data-area-property-exact]'),
        billable: form.querySelector('[data-area-property-billable]')
      };
      const tierSelect = selects[1];
      const currency = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 });
      const decimal = new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

      const relabelJobs = () => {
        const rows = Array.from(jobsContainer.querySelectorAll('[data-area-job]'));
        rows.forEach((row, index) => {
          const number = index + 1;
          row.querySelector('[data-area-job-name]').textContent = `${calculator.dataset.jobLabel} ${number}`;
          row.querySelector('[data-area-width]').setAttribute('aria-label', `${calculator.dataset.widthLabel} · ${calculator.dataset.jobLabel} ${number}`);
          row.querySelector('[data-area-height]').setAttribute('aria-label', `${calculator.dataset.heightLabel} · ${calculator.dataset.jobLabel} ${number}`);
          row.querySelector('[data-area-pieces]').setAttribute('aria-label', `${calculator.dataset.piecesLabel} · ${calculator.dataset.jobLabel} ${number}`);
          row.querySelector('[data-area-remove]').setAttribute('aria-label', `${calculator.dataset.removeLabel} ${number}`);
          row.querySelector('[data-area-job-property]').name = `properties[${calculator.dataset.jobLabel} ${number}]`;
        });
        calculator.toggleAttribute('data-single-job', rows.length === 1);
      };

      const createJob = (values = {}) => {
        const row = document.createElement('div');
        row.className = 'ng-area-calculator__job';
        row.setAttribute('data-area-job', '');
        row.innerHTML = `
          <strong class="ng-area-calculator__job-name" data-area-job-name></strong>
          <label class="visually-hidden"><span>${calculator.dataset.widthLabel}</span><input class="ng-input" type="number" min="1" step="1" inputmode="decimal" data-area-width required></label>
          <label class="visually-hidden"><span>${calculator.dataset.heightLabel}</span><input class="ng-input" type="number" min="1" step="1" inputmode="decimal" data-area-height required></label>
          <label class="visually-hidden"><span>${calculator.dataset.piecesLabel}</span><input class="ng-input" type="number" min="1" step="1" inputmode="numeric" data-area-pieces required></label>
          <strong class="ng-area-calculator__job-area" data-area-job-area>0,00 m²</strong>
          <button class="ng-area-calculator__remove" type="button" data-area-remove aria-label="${calculator.dataset.removeLabel}">×</button>
          <input type="hidden" data-area-job-property>
        `;
        row.querySelector('[data-area-width]').value = values.width || '';
        row.querySelector('[data-area-height]').value = values.height || '';
        row.querySelector('[data-area-pieces]').value = values.pieces || 1;
        jobsContainer.appendChild(row);
        relabelJobs();
      };

      const calculate = () => {
        const rows = Array.from(jobsContainer.querySelectorAll('[data-area-job]'));
        let exactArea = 0;
        let valid = rows.length > 0;

        rows.forEach((row) => {
          const widthValue = Number(row.querySelector('[data-area-width]').value);
          const heightValue = Number(row.querySelector('[data-area-height]').value);
          const piecesValue = Number(row.querySelector('[data-area-pieces]').value);
          const rowValid = widthValue > 0 && heightValue > 0 && Number.isInteger(piecesValue) && piecesValue > 0;
          valid = valid && rowValid;
          const rowArea = rowValid ? (widthValue * heightValue * piecesValue) / 10000 : 0;
          exactArea += rowArea;
          row.querySelector('[data-area-job-area]').textContent = `${decimal.format(rowArea)} m²`;
          row.querySelector('[data-area-job-property]').value = rowValid
            ? `${widthValue} × ${heightValue} cm · ${piecesValue} piezas · ${decimal.format(rowArea)} m²`
            : '';
        });

        if (!valid) {
          result.textContent = 'Ingresa ancho, alto y cantidad para calcular el pedido.';
          properties.jobsCount.value = rows.length;
          properties.exact.value = '';
          properties.billable.value = '';
          if (submit) {
            submit.disabled = true;
            submit.textContent = submit.dataset.measurementsText;
          }
          return;
        }

        const billableArea = Math.max(1, Math.ceil(exactArea * 4) / 4);
        const billingUnits = Math.round(billableArea * 4);
        const bulkTier = exactArea >= 10;
        const tierOption = Array.from(tierSelect?.options || []).find((option) => {
          const value = option.value.toLocaleLowerCase('es-CL');
          if (bulkTier) return value.includes('10') && (value.includes('más') || value.includes('desde'));
          return value.includes('1') && value.includes('9');
        });
        if (tierOption) tierSelect.value = tierOption.value;
        const variant = findVariant();
        if (!variant) {
          applyVariant(null);
          return;
        }

        const totalCents = Number(variant.priceCents) * billingUnits;
        const unitPrice = currency.format((Number(variant.priceCents) * 4) / 100);
        const totalPrice = currency.format(totalCents / 100);
        quantity.value = billingUnits;
        properties.jobsCount.value = rows.length;
        properties.exact.value = `${decimal.format(exactArea)} m²`;
        properties.billable.value = `${decimal.format(billableArea)} m²`;
        result.innerHTML = `<strong>${decimal.format(exactArea)} m² reales · ${decimal.format(billableArea)} m² facturables</strong><span>${unitPrice}/m² · Total ${totalPrice}</span>`;
        if (price) price.textContent = unitPrice;
        applyVariant(variant, false);
      };

      jobsContainer.addEventListener('input', calculate);
      jobsContainer.addEventListener('change', calculate);
      jobsContainer.addEventListener('click', (event) => {
        const removeButton = event.target.closest('[data-area-remove]');
        if (!removeButton) return;
        const rows = jobsContainer.querySelectorAll('[data-area-job]');
        if (rows.length === 1) return;
        removeButton.closest('[data-area-job]').remove();
        relabelJobs();
        calculate();
      });
      addJobButton.addEventListener('click', () => {
        createJob();
        calculate();
        jobsContainer.lastElementChild.querySelector('[data-area-width]').focus();
      });
      selects[0].addEventListener('input', calculate);
      selects[0].addEventListener('change', calculate);
      createJob();
      calculate();
      return;
    }

    selects.forEach((select) => {
      select.addEventListener('change', () => {
        let variant = findVariant();
        if (!variant) {
          const changedIndex = Number(select.dataset.optionIndex);
          const selected = selects.map((item) => item.value);
          variant = variants.find((candidate) => candidate.available && candidate.options.every((option, index) => index <= changedIndex ? option === selected[index] : true));
          if (!variant) variant = variants.find((candidate) => candidate.available && candidate.options[0] === selected[0]);
          if (variant) selects.forEach((item, index) => { item.value = variant.options[index]; });
        }
        applyVariant(variant);
      });
    });
    applyVariant(findVariant());
  });
});
